module.exports = __webpack_public_path__ + "img/entypo-traffic-cone.0308cb4a.svg";